import Provider from "./hooks"

export default function passwordChange() {
  return <Provider />
}
